import React, { useState, useEffect } from "react";
import CarProduct from "../components/CarProduct";
import "../assets/css/Homestyle.css";
import SearchBar from "../components/SearchBar";
import BrandAll from "../components/BrandAll";
import Pagination from "../components/Pagination";

import { getFirestore, collection, getDocs } from "firebase/firestore";
import { app } from "../Firebase/Firebaseapp";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../components/Spinner";
import {
  featchCarData,
  getPaginationData,
  nextPaginationData,
} from "../Redux/Slice/DataSlice";
import ScrollToTop from "react-scroll-to-top";

const fireStoreDb = getFirestore(app);

const Cars = () => {
  const dispatch = useDispatch();
  const { Cardetails, searchReasult, PaginationData, status } = useSelector(
    (state) => state.CarData
  );

  const [Brand, setBrands] = useState([]);

  const BrandsData = () => {
    return getDocs(collection(fireStoreDb, "Brands"));
  };

  useEffect(() => {
    dispatch(featchCarData()).then(() => {
      dispatch(getPaginationData());
      dispatch(nextPaginationData({ Lower: 0, Upper: 2 }));
    });
    BrandsData().then((brands) => setBrands(brands.docs));
  }, []);

  return (
    <>
      <div className="w-[100%]">
        {status === "pending" ? 
        <Spinner/>
         : (
          <div className="w-[100%]">
            <div className=" sm:h-[12vh] h-auto w-[100%] bg-black ">
              <SearchBar />
            </div>

            <div className="min-h-[50vh] w-[100%]  flex sm:flex-row flex-col  mb-12  text-black sm:gap-1  gap-2">
              <div className="sm:w-[80%] w-[100%] flex justify-center items-center flex-col">
                {searchReasult.length == 0 ? (
                  PaginationData.length == 0 ? (
                    <h1 className=" font-bold font-serif text-[20px] hidden sm:block">
                      Data Loading
                    </h1>
                  ) : (
                    PaginationData.map((x, index) => {
                      return <CarProduct car={x} key={index} />;
                    })
                  )
                ) : (
                  searchReasult.map((x, index) => {
                    return <CarProduct car={x} key={index} />;
                  })
                )}
              </div>

              <div className="  flex items-center sm:flex-col flex-row  mt-5">
                <h1 className=" font-bold font-serif text-[20px] hidden sm:block">
                  BRANDS
                </h1>
                {Brand &&
                  Brand.map((x, index) => {
                    return <BrandAll Brand={x.data()} />;
                  })}
              </div>
            </div>

            <Pagination />

            <ScrollToTop
              smooth="true"
              color="white"
              style={{ backgroundColor: "crimson", padding: "5px" }}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default Cars;
